import type { CSSProperties } from 'react';
import React from 'react';
import { Card } from './Card';

interface PhotoCardProps {
  children: React.ReactNode;
  imageSrc: string;
  className?: string;
  hover?: boolean;
  opacity?: number;
  opacityHover?: number;
}

export const PhotoCard: React.FC<PhotoCardProps> = ({
  children,
  imageSrc,
  className = '',
  hover = true,
  opacity = 0.42,
  opacityHover = 0.55,
}) => (
  <Card
    hover={hover}
    className={`group relative overflow-hidden bg-gray-950 text-white hover:text-yellow-300 dark:bg-gray-950 dark:text-white dark:hover:text-yellow-300 ${className}`}
  >
    <img
      src={imageSrc}
      alt=""
      aria-hidden="true"
      loading="lazy"
      decoding="async"
      className="km-photo-card-img pointer-events-none absolute inset-0 h-full w-full object-cover grayscale"
      style={{
        '--km-photo-o': opacity,
        '--km-photo-oh': opacityHover,
      } as CSSProperties}
    />
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/75 via-black/45 to-black/25"
    />
    <div className="relative z-10">{children}</div>
  </Card>
);
